// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xk_a bhl_a bhl_x","StrollerDetailRating__muted":"xk_b bhl_fm"};